import React from 'react'

function MedcardList() {
  return (
    <div>Tıbbi Kart Listesi</div>
  )
}

export default MedcardList